<template>
  <div class="topSearch">
    <div class="proTop d-flex j-sb a-start">
      <div class="ptLeft">
        <h3 class="font36 corfff">{{ content.name }}</h3>
        <div class="tags d-flex f-wrap">
          <span
            class="font14"
            v-for="(item, index) in content.tag ? content.tag.split(',') : []"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
      <!-- 筛选 -->
      <div class="cTopFrom d-flex">
        <div class="select">
          <select v-model="searchType">
            <option value="product">{{ $t('search.product') }}</option>
            <option value="version">{{ $t('search.package') }}</option>
            <option value="document">{{ $t('search.document') }}</option>
            <option value="train">{{ $t('search.train') }}</option>
            <option value="faq">{{ $t('search.faq') }}</option>
            <option value="activity">{{ $t('search.activity') }}</option>
          </select>
        </div>
        <div class="from pr">
          <input
            type="text"
            v-model="searchKey"
            @keyup.enter="goSearch"
            class="t"
            :placeholder="$t('search.keyPlaceholder')"
          />
          <button class="s pointer" @click="goSearch"></button>
        </div>
      </div>
    </div>

    <!-- 分类/类别 -->
    <div class="proCategory">
      <ul class="d-flex bd10">
        <li
          @click="goToPage(item.url + '?productId=' + $route.query.productId)"
          :class="[
            'd-flex font20 font-medium j-center a-center pointer',
            { active: current(item.url) },
          ]"
          v-for="(item, index) in categoryList"
          :key="index"
        >
          <figure><img :src="item.imageUrl" class="w100" alt="" /></figure>
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  props: {
    search_type: String,
    search_key: String,
  },
  components: {},
  data() {
    return {
      searchType: this.search_type || "product",
      searchKey: this.search_key,
      // 类别
      categoryList: [
        {
          id: 1,
          title: this.$t('admin.website'),
          imageUrl: require("@/assets/Icons/proHome.png"),
          url: "/productDirectory",
        },
        {
          id: 2,
          title: this.$t('search.package'),
          imageUrl: require("@/assets/Icons/proZip.png"),
          url: "/productPackage",
        },
        {
          id: 3,
          title: this.$t('search.document'),
          imageUrl: require("@/assets/Icons/proDocument.png"),
          url: "/productDocument",
        },
        {
          id: 4,
          title: this.$t('search.train'),
          imageUrl: require("@/assets/Icons/proTrain.png"),
          url: "/productTrain",
        },
        {
          id: 5,
          title: this.$t('search.faq'),
          imageUrl: require("@/assets/Icons/proQuestion.png"),
          url: "/productQuestion",
        },
      ],
      // 类别选中，默认第一个
      categoryChecked: 0,
      // 详细内容
      content: {},
    };
  },

  computed: {
    // 菜单当前选中
    current: function () {
      return function (url) {
        return this.$route.path.indexOf(url) >= 0 ? true : false;
      };
    },
  },
  watch: {
    search_type: function () {
      this.searchType = this.search_type;
    },
  },
  created() {
    // 获取产品首页
    this.getProductChildren(this.$route.query.productId);
  },

  methods: {
    // 页面跳转
    goToPage(path, query = {}) {
      this.$router.push({
        path,
        query,
      });
    },
    goSearch: function () {
      if (this.$route.path == "/search") {
        this.$emit("search", {
          type: this.searchType,
          key: this.searchKey,
        });
      } else {
        this.$router.push({
          path: "/search",
          query: {
            type: this.searchType,
            kw: this.searchKey,
          },
        });
      }
    },
    /**
     * 获取该产品下的类型
     * @type 类型
     */
    getProductChildren(id) {
      this.$axios
        .post(`product/index`, { productId: id })
        .then((res) => {
          let data = res.data;
          // 当前产品信息
          this.content = data.product;
        })
        .catch((err) => {});
    },
  },

  // 监听路由变化
};
</script>

<style lang="less" scoped>
.proTop {
  padding: 0.5rem 0 0.8rem;
  .ptLeft {
    h3 {
      margin-bottom: 0.3rem;
    }
  }
  .tags {
    span {
      display: inline-block;
      padding: 0.05rem 0.08rem;
      border-radius: 0.15rem;
      background: #5794f8;
      color: #fff;
      margin-right: 0.1rem;
    }
  }
  .cTopFrom {
    margin: 0;
  }
  @media (max-width: 1200px) {
    display: block;
    .cTopFrom {
      margin: 0.3rem auto 0;
    }
  }
}
.proCategory {
  margin-bottom: 0.1rem;
  ul {
    background: #f5f7fa;
    li {
      width: 25%;
      height: 0.7rem;
      &:not(:last-child) {
        background: url(@/assets/Icons/pcLine.png) no-repeat right center/auto
          0.2rem;
      }
      &:hover,
      &.active {
        background: #fff;
        color: #2657db;
      }
      figure {
        width: 0.2rem;
        margin-right: 0.1rem;
      }
    }
  }
  @media (max-width: 640px) {
    ul {
      flex-wrap: wrap;
      li {
        width: 33.33%;
      }
    }
  }
}
</style>
